import type { UserFeatureFlags, UserFeatureFlagsDTO } from './featureFlags.types';

// eslint-disable-next-line import/prefer-default-export
export const parseFeatureFlagsForFE = (raw: UserFeatureFlagsDTO): UserFeatureFlags => ({
  displayTaskTable: raw.display_task_table,
  canFilterAssets: raw.can_filter_assets,
});
